module.exports = __webpack_public_path__ + "static/img/rjqy.5a7871b9.jpg";